export const SET_HAS_ACTIVE_CAMPAIGN = 'SET_HAS_ACTIVE_CAMPAIGN';
export const SET_CAMPAIGN_INFO = 'SET_CAMPAIGN_INFO';
export const TRIGGER_CAMPAIGN = 'TRIGGER_CAMPAIGN';
